import React, { useEffect, useMemo } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { makeStyles, useTheme, useMediaQuery } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import Results from './Results.js';
import ToolBar from './ToolBar.js';
import { PAGE_SIZE_LIST, STATUS_API } from 'src/app/constant/config';
import { getListProvinces } from 'src/features/provinceSlice.js';
import { useQuery } from 'src/app/hooks/useQuery.js';
import { _convertObjectToQuery } from 'src/app/utils/apiService.js';
import { getListAgencies } from 'src/features/agencySlice.js';

const AgenciesManage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const query = useQuery();
  const classes = useStyles();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  const listAgencies = useSelector(state => state.agencySlice.listAgencies);
  const totalAgencies = useSelector(state => state.agencySlice.totalAgencies);
  const listProvinces = useSelector(state => state.provinceSlice.listProvinces);

  const {
    statusCreate,
    statusUpdate,
    statusDelete,
    statusDeleteMulti,
    statusTransfer
  } = useSelector(state => state.agencySlice);

  const params = useMemo(() => {
    return {
      page: Number(query.get('page')) || 1,
      citizen_id: query.get('citizen_id') || undefined,
      keywords: query.get('keywords') || undefined,
      page_size: isMobile ? 6 : PAGE_SIZE_LIST
    };
  }, [query, isMobile]);

  useEffect(() => {
    dispatch(getListAgencies(params));
  }, [params]);

  useEffect(() => {
    dispatch(getListProvinces());
  }, []);

  const updateQuery = nextParams => {
    navigate('/app/manage/agencies?' + _convertObjectToQuery(nextParams));
  };

  useEffect(() => {
    if (
      statusCreate === STATUS_API.SUCCESS ||
      statusUpdate === STATUS_API.SUCCESS ||
      statusDelete === STATUS_API.SUCCESS ||
      statusDeleteMulti === STATUS_API.SUCCESS ||
      statusTransfer === STATUS_API.SUCCESS
    ) {
      dispatch(getListAgencies(params));
    }
  }, [
    statusCreate,
    statusUpdate,
    statusDelete,
    statusDeleteMulti,
    statusTransfer,
    params
  ]);

  return (
    <div className={classes.root}>
      <div style={{ width: '98%', margin: '0 auto' }}>
        <ToolBar searchRef={updateQuery} listProvinces={listProvinces} />
        <Results
          className="mt-3"
          totalAgencies={totalAgencies}
          listAgencies={listAgencies}
          getListAgenciesRef={updateQuery}
          currentParams={params}
        />
      </div>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    width: '100%',
    paddingTop: theme.spacing(2)
  }
}));

const AgenciesGuard = () => {
  const isAgency = useSelector(state => state.authSlice.isAgency);
  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const { isAccountant, isSale } = useSelector(state => state.authSlice);
  const dataLogin = useSelector(state => state.authSlice.dataLogin);

  if (!dataLogin) return null;

  const isAllowed = isAdmin || isAgency || isAccountant || isSale;
  if (!isAllowed) {
    return <Navigate to="/app/tracking" replace />;
  }

  return <AgenciesManage />;
};

export default AgenciesGuard;
